exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  margin: 0 auto;\n  padding: 40px 0; }\n  form label {\n    font-weight: bold; }\n\nh2 {\n  margin-top: 150px; }\n\n.message, .subtitle {\n  margin: 0 auto;\n  padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Mustafa/Developpement/noxoe/src/components/reset-password/reset-password.component.scss
// module id = ../../../../../src/components/reset-password/reset-password.component.scss
// module chunks = main